import Form from "react-bootstrap/Form";
import { useTranslation } from "react-i18next";
import type { PlayerStatistics } from "../../types/domain";
import { getLadderName } from "../../util/HelperUtils";

interface PlayerLadderSelectProps {
  playerStatistics: PlayerStatistics[];
  selectedLadderId: number | null;
  onChange: (ladderId: number) => void;
}

/**
 * Dropdown listing all ladders the player has stats in. Order comes from the backend already
 * (default first, then officials, then unofficials by activity desc) so we render as-is.
 */
function PlayerLadderSelect({ playerStatistics, selectedLadderId, onChange }: PlayerLadderSelectProps) {
  const { i18n } = useTranslation();
  if (playerStatistics.length <= 1) return null;
  return (
    <div className="mb-3 mt-3 d-flex justify-content-center">
      <Form.Select
        style={{ maxWidth: 320 }}
        value={selectedLadderId ?? ""}
        onChange={(e) => onChange(Number(e.target.value))}
      >
        {playerStatistics.map((s) => (
          <option key={s.ladder.id} value={s.ladder.id}>
            {getLadderName(i18n, s.ladder)}
          </option>
        ))}
      </Form.Select>
    </div>
  );
}

export default PlayerLadderSelect;
